<template>
  <i
    v-if="isLoading"
    class="fa-solid fa-circle-notch absolute left-[calc(50%-24px)] top-[calc(50%-24px)] h-12 w-12 animate-spin text-[48px] text-violet-700"
  />
</template>

<script setup>
import { inject } from "vue"

const { isLoading } = inject("LOADING_STATE")
</script>
